export default __webpack_public_path__ + "static/media/icon-favourite-clicked.5537cad5.svg";